import React, { useEffect, useMemo, useState } from "react";
import { addUserSifarish, updateUserSifarish } from "_services";
import {
  CommonInput,
  CommonModal,
  CommonMovieSearch,
  CommonTextarea,
  CustomSelect,
  GoogleCitySearch,
  GooglePlaceSearch,
} from "components";
import { toast } from "react-hot-toast";
import { MdCancel, MdDelete } from "react-icons/md";
import { FaRegImage } from "react-icons/fa6";
import { uploadFile } from "_services/userService";

const AddSifarishModal = (props) => {
  const masterUserId = props?.userData?._id;
  const initialFormValues = {
    userId: masterUserId,
    title: "",
    description: "",
    categoryId: "",
    privacy: 1,
    isAuto: 1,
    mediaUrls: [],
    address: {
      city: "",
      state: "",
      country: "",
      latitude: "",
      longitude: "",
      zipcode: "",
    },
    subCategoryId: "",
    genreId: "",
    links: [{ linkTypeId: "", url: "" }],
    contactName: "",
    phoneNumber: "",
    alternatePhoneNumber: "+",
    email: "",
    contentTitle: "",
    birdId: "",
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [genresList, setGenresList] = useState([]);
  const [birds, setBirds] = useState([]);
  const [selectedSubCategoryData, setSelectedSubCategoryData] = useState(null);
  const [locationData, setLocationData] = useState({
    photos: [],
    coordinates: {},
  });
  const [nearbyPlaces, setNearbyPlaces] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isDisable, setIsDisable] = useState(false);
  const [isEditInitialized, setIsEditInitialized] = useState(false);
  const [editGenreVal, setEditGenreVal] = useState("");
  const [editArrayIndex, setEditArrayIndex] = useState(0);
  const [sifarishArray, setSifarishArray] = useState([]);

  const getMasterData = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("masterData"));
    } catch {
      return null;
    }
  }, []);

  const constant = {
    DETAIL_SEARCH_OPTION: [
      { label: "Auto-fill by location", value: 1 },
      { label: "Manual entry", value: 2 },
    ],
    COMMENT_VISIBILITY: [
      { label: "Public", value: 1 },
      { label: "Private", value: 2 },
    ],
    RECOMMENDED: [
      { label: "Yes", value: 1 },
      { label: "No", value: 2 },
    ],
  };

  useEffect(() => {
    const editArray = props?.sifarishArrayToEdit?.allSifarishToEdit || [];

    if (
      Array.isArray(editArray) &&
      editArray.length > 0 &&
      categories.length > 0 &&
      birds.length > 0
    ) {
      setSifarishArray([...editArray]);

      const rawIndex = Number.isInteger(props?.sifarishInd)
        ? props.sifarishInd
        : 0;
      const startIndex = Math.max(0, Math.min(rawIndex, editArray.length - 1));

      setEditArrayIndex(startIndex);
      prefillEditData(editArray[startIndex]);
      setIsEditInitialized(true);
    }
  }, [props?.sifarishArrayToEdit, categories, birds]);

  useEffect(() => {
    if (formValues?.birdId && formValues?.title && formValues?.categoryId) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
  }, [formValues]);

  useEffect(() => {
    const category = categories.find((c) => c._id === formValues.categoryId);
    setSelectedCategory(category?.title || null);
    setSelectedSubCategoryData(null);
  }, [formValues.categoryId, categories]);

  useEffect(() => {
    if (props?.sifarishToEdit && categories.length > 0 && birds.length > 0) {
      const editData = props.sifarishToEdit;
      const category = categories.find(
        (c) => c._id === editData.categoryId._id
      );
      // const bird = birds.find((b) => b._id === editData.birdId._id);

      if (category && editData.subCategoryId) {
        const subCategory = category.subCategories.find(
          (sc) => sc._id === editData.subCategoryId
        );
        setSelectedSubCategoryData(subCategory);
        setEditGenreVal(subCategory);
      }
      const newFormValues = {
        ...initialFormValues,
        userId: masterUserId,
        title: editData.title,
        description: editData.description,
        categoryId: editData.categoryId._id,
        privacy: editData.privacy,
        mediaUrls: editData.mediaUrls,
        address: editData.address,
        subCategoryId: editData.subCategoryId || "",
        genreId: editData.genreId?._id || "",
        links: editData?.links?.map((link) => ({
          linkTypeId: link.linkType._id,
          url: link.url,
        })),
        contactName: editData.contactName,
        phoneNumber: editData.phoneNumber,
        alternatePhoneNumber: editData.alternatePhoneNumber,
        email: editData.email,
        contentTitle: editData.genreId?._id ? editData.title : "",
        birdId: editData?.birdId?._id,
        sifarishId: editData._id,
      };

      if (category) {
        const subCategories = category.subCategories.map((sc) => ({
          label: sc.title,
          value: sc._id,
        }));
        setSubCategoryList(subCategories);
      }

      setFormValues(newFormValues);
      setIsEditInitialized(true);
    }
  }, [props?.sifarishToEdit, categories, birds]);

  useEffect(() => {
    if (formValues.categoryId && !isEditInitialized) {
      setFormValues((prev) => ({
        ...initialFormValues,
        categoryId: prev.categoryId,
        birdId: prev.birdId,
        userId: prev.userId,
        privacy: prev.privacy,
        isAuto: prev.isAuto,
      }));
      setSubCategoryList([]);
      setSelectedSubCategoryData(null);
    }
  }, [formValues.categoryId, isEditInitialized]);

  useEffect(() => {
    if (locationData) {
      const processedMedia = (locationData?.photos || [])
        .slice(0, 3)
        .map((photoUrl) => ({
          url: photoUrl,
          type: getFileTypeFromURL(photoUrl),
        }));

      const matchLinkId =
        getMasterData?.linkTypes?.find((item) => item.title === "Website")
          ?._id || "";

      setFormValues((prev) => {
        // If editing and there are existing media, append new media (avoid duplicates)
        let updatedMediaUrls = processedMedia;
        if (isEditInitialized && prev.mediaUrls && prev.mediaUrls.length > 0) {
          // Filter out duplicates by URL
          const existingUrls = new Set(prev.mediaUrls.map((m) => m.url));
          const newMedia = processedMedia.filter((m) => !existingUrls.has(m.url));
          updatedMediaUrls = [...prev.mediaUrls, ...newMedia];
        }

        return {
          ...prev,
          mediaUrls: updatedMediaUrls,
          title: locationData?.name || prev.title || "",
          address: {
            city: locationData?.city || prev.address?.city || "",
            state: locationData?.state || prev.address?.state || "",
            country: locationData?.country || prev.address?.country || "",
            latitude: locationData?.coordinates?.lat || prev.address?.latitude || "",
            longitude: locationData?.coordinates?.lng || prev.address?.longitude || "",
            zipcode: locationData?.postalCode || prev.address?.zipcode || "",
          },
          links: [
            {
              linkTypeId: locationData.website ? matchLinkId : "",
              url: locationData.website || "",
            },
          ],
          phoneNumber: locationData.phone || prev.phoneNumber || "",
          email: locationData.email || prev.email || "",
        };
      });
    }
  }, [locationData, isEditInitialized]);

  useEffect(() => {
    const birdsFromStorage = getMasterData?.birds || [];
    const categoriesFromStorage = getMasterData?.categories || [];
    const genresFromStorage = getMasterData?.genres || [];

    setBirds(birdsFromStorage);
    setCategories(categoriesFromStorage);
    setGenresList(
      genresFromStorage.map((g) => ({ label: g.title, value: g._id }))
    );
  }, [getMasterData]);

  useEffect(() => {
    if (formValues.categoryId) {
      const category = categories.find((c) => c._id === formValues.categoryId);
      if (category?.subCategories?.length) {
        setSubCategoryList(
          category.subCategories.map((sc) => ({
            label: sc.title,
            value: sc._id,
          }))
        );
      }
      if (isEditInitialized && category?.title === "Contents") {
        setSelectedSubCategoryData(editGenreVal);
      } else {
        setSelectedSubCategoryData(null);
      }
    }
  }, [formValues.categoryId, categories]);

  const handleChange = (name, value) => {
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (name, option) => {
    handleChange(name, option?.value || "");
  };

  const handleArrayChange = (arrayName, index, field, value) => {
    setFormValues((prev) => {
      const updatedArray = [...prev[arrayName]];
      updatedArray[index] = { ...updatedArray[index], [field]: value };
      return { ...prev, [arrayName]: updatedArray };
    });
  };

  const getFileTypeFromURL = (url) => {
    const extension = url?.split(".").pop().split(/[#?]/)[0].toLowerCase();
    const validTypes = ["jpg", "jpeg", "png", "gif", "webp"];
    return validTypes.includes(extension) ? extension : "jpg";
  };

  const linkTypeOptions = useMemo(
    () =>
      (getMasterData?.linkTypes || []).map((lt) => ({
        label: lt.title,
        value: lt._id,
        icon: lt.imageUrl,
      })),
    [getMasterData?.linkTypes]
  );

  const handleMovieSelect = (movieData) => {
    const mediaUrls = [];

    if (movieData.Poster && movieData.Poster !== "N/A") {
      const type = getFileTypeFromURL(movieData.Poster);
      mediaUrls.push({ url: movieData.Poster, type });
    }

    setFormValues((prev) => ({
      ...prev,
      title: movieData.Title || "",
      description: movieData.Plot || "",
      mediaUrls,
      contentTitle: movieData.Title || "",
    }));
  };

  const shouldShowMainForm = useMemo(() => {
    if (props?.sifarishToEdit) return true;

    if (selectedCategory === "Stay") return !!locationData;

    const subCategoryConfig = categories
      .find((c) => c._id === formValues.categoryId)
      ?.subCategories?.find((sc) => sc._id === formValues.subCategoryId);

    if (selectedCategory === "Contents") {
      if (subCategoryConfig?.isGenre) {
        return !!formValues.genreId;
      }
      return !!formValues.contentTitle;
    }

    return true;
  }, [
    props?.sifarishToEdit,
    selectedCategory,
    formValues.categoryId,
    formValues.subCategoryId,
    formValues.genreId,
    formValues.contentTitle,
    locationData,
    categories,
  ]);

  const prefillEditData = (editData) => {
    if (!editData) return;
    const category = categories.find((c) => c._id === editData.categoryId?._id);
    const subCategory = category?.subCategories?.find(
      (sc) => sc._id === editData.subCategoryId
    );
    setSelectedSubCategoryData(subCategory || null);

    if (category) {
      const subCategories = category.subCategories.map((sc) => ({
        label: sc.title,
        value: sc._id,
      }));
      setSubCategoryList(subCategories);
    } else {
      setSubCategoryList([]);
    }

    setFormValues({
      ...initialFormValues,
      userId: masterUserId,
      title: editData.title || "",
      description: editData.description || "",
      categoryId: editData.categoryId?._id || "",
      privacy: editData.privacy || 1,
      mediaUrls: editData.mediaUrls || [],
      address: editData.address || initialFormValues.address,
      subCategoryId: editData.subCategoryId || "",
      genreId: editData.genreId?._id || "",
      links: editData.links?.map((l) => ({
        linkTypeId: l.linkType?._id || "",
        url: l.url || "",
      })) || [{ linkTypeId: "", url: "" }],
      contactName: editData.contactName || "",
      phoneNumber: editData.phoneNumber || "",
      alternatePhoneNumber: editData.alternatePhoneNumber || "+",
      email: editData.email || "",
      contentTitle: editData.genreId?._id ? editData.title : "",
      birdId: editData.birdId?._id || "",
      sifarishId: editData._id,
    });

    setIsEditInitialized(true);
  };

  const handleUpdateAndContinue = async () => {
    const result = await handleUpdateSubmit("editAll");
    if (!result.ok) {
      return;
    }

    setEditArrayIndex((prevIndex) => {
      const nextIndex = prevIndex + 1;

      if (Array.isArray(sifarishArray) && nextIndex < sifarishArray.length) {
        prefillEditData(sifarishArray[nextIndex]);

        toast.success(`Loaded next record (${nextIndex + 1}/${sifarishArray.length})`);
        return nextIndex;
      } else {
        toast.success("All records updated successfully!");
        newObject?.closeModal();
        return prevIndex;
      }
    });
  };


  const handleSubmit = () => {
    if (isEditInitialized) {
      handleUpdateSubmit("onlyEdit");
    } else {
      handleAddSubmit();
    }
  };

  const handleAddSubmit = async () => {
    try {
      const payload = {
        ...formValues,
      };
      const validLinks = payload.links.filter(
        (link) => link.linkTypeId && link.url
      );
      delete payload.isAuto;
      if (!formValues?.genreId) {
        delete payload.genreId;
      }
      if (formValues?.genreId) {
        delete payload.links;
      }

      if (validLinks.length === 0) {
        delete payload.links;
      } else {
        payload.links = validLinks;
      }
      const response = await addUserSifarish(payload);
      // modalProps?.closeModal();
      const successMessage = response?.message || "User updated successfully!";
      toast.success(successMessage);
      if (newObject.onSuccess) {
        newObject.onSuccess();
      }
    } catch (err) {
      toast.error(err);
    } finally {
      newObject?.closeModal();
    }
  };

  const handleContinueSubmit = async () => {
    try {
      const payload = {
        ...formValues,
      };
      const validLinks = payload.links.filter(
        (link) => link.linkTypeId && link.url
      );
      delete payload.isAuto;
      if (!formValues?.genreId) {
        delete payload.genreId;
      }
      if (formValues?.genreId) {
        delete payload.links;
      }

      if (validLinks.length === 0) {
        delete payload.links;
      } else {
        payload.links = validLinks;
      }
      const response = await addUserSifarish(payload);
      const successMessage = response?.message || "User updated successfully!";
      toast.success(successMessage);
      if (newObject.onSuccess) {
        newObject.onSuccess();
      }
      setFormValues(initialFormValues);
    } catch (err) {
      toast.error(err);
    }
  };

  // const handleUpdateSubmit = async (type) => {
  //   try {
  //     const payload = {
  //       ...formValues,
  //     };
  //     delete payload.isAuto;
  //     if (!formValues?.genreId) {
  //       delete payload.genreId;
  //     }
  //     if (formValues?.genreId) {
  //       delete payload.links;
  //     }
  //     if (!formValues?.subCategoryId) {
  //       delete payload.subCategoryId;
  //     }

  //     if (
  //       Array.isArray(formValues?.links) &&
  //       formValues.links.every(
  //         (item) => !item.linkTypeId?.trim() && !item.url?.trim()
  //       )
  //     ) {
  //       delete payload.links;
  //     }

  //     const response = await updateUserSifarish(payload);
  //     // modalProps?.closeModal();
  //     const successMessage = response?.message || "User updated successfully!";
  //     toast.success(successMessage);
  //     if (newObject.onSuccess) {
  //       newObject.onSuccess();
  //     }
  //   } catch (err) {
  //     toast.error(err);
  //   } finally {
  //     if (type === "onlyEdit") {
  //       newObject?.closeModal();
  //     }
  //   }
  // };

  const handleUpdateSubmit = async (type) => {
    try {
      const payload = {
        ...formValues,
      };
      if (!payload.sifarishId && formValues?.sifarishId) {
        payload.sifarishId = formValues.sifarishId;
      }

      delete payload.isAuto;
      if (!formValues?.genreId) {
        delete payload.genreId;
      }
      if (formValues?.genreId) {
        delete payload.links;
      }
      if (!formValues?.subCategoryId) {
        delete payload.subCategoryId;
      }

      if (
        Array.isArray(formValues?.links) &&
        formValues.links.every(
          (item) => !item.linkTypeId?.trim() && !item.url?.trim()
        )
      ) {
        delete payload.links;
      }

      const response = await updateUserSifarish(payload);
      const successMessage = response?.message || "User updated successfully!";
      toast.success(successMessage);
      if (type === "onlyEdit") {
        if (newObject.onSuccess) {
          newObject.onSuccess();
        }
      }

      return { ok: true, response };
    } catch (err) {
      toast.error(err?.message || err);
      return { ok: false, error: err };
    } finally {
      if (type === "onlyEdit") {
        newObject?.closeModal();
      }
    }
  };

  const handleAddLink = () => {
    setFormValues((prev) => ({
      ...prev,
      links: [...prev.links, { linkTypeId: "", url: "" }],
    }));
  };

  const handleRemoveLink = (index) => {
    setFormValues((prev) => {
      const updatedLinks = [...prev.links];
      updatedLinks.splice(index, 1);
      return { ...prev, links: updatedLinks };
    });
  };

  const handleFileUpload = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) return;

      const response = await uploadFile(file);

      if (response?.data?.file?.fullUrl) {
        const url = response.data.file.fullUrl;
        const originalName = response.data.file.originalname;
        const extension = originalName?.split(".").pop();

        setFormValues((prev) => ({
          ...prev,
          mediaUrls: [
            ...(prev.mediaUrls || []),
            {
              url: url,
              type: extension,
            },
          ],
        }));
      }
    } catch (err) {
      toast.error("Upload failed");
    }
  };

  const handleDeleteImg = (object, index) => {
    setFormValues((prev) => ({
      ...prev,
      mediaUrls: prev.mediaUrls.filter((item, i) => {
        if (object._id) {
          return item._id !== object._id;
        }
        return i !== index;
      }),
    }));
  };

  // let newObject = {
  //   ...props,
  //   onSubmit: () => handleSubmit(),
  //   disabled: isDisable,
  //   isContinueSubmit: isEditInitialized ? false : true,
  //   handleContinueSubmit: () => handleContinueSubmit(),
  //   continueTitle: "Save and Continue",
  // };

  let newObject = {
    ...props,
    onSubmit: () => handleSubmit(),
    disabled: isDisable,
    isContinueSubmit: true,
    handleContinueSubmit: isEditInitialized
      ? () => handleUpdateAndContinue()
      : () => handleContinueSubmit(),
    continueTitle: isEditInitialized
      ? "Update & Continue"
      : "Save and Continue",
  };

  return (
    <>
      <CommonModal {...newObject}>
        <div className="addLr_body">
          <div className="_allDflx_nw">
            {birds.length > 0 && (
              <div className="_dualDivs">
                <CustomSelect
                  key={`bird-select-${formValues.birdId}`}
                  options={birds.map((b) => ({ label: b.title, value: b._id }))}
                  value={
                    birds
                      .map((b) => ({ label: b.title, value: b._id }))
                      .find((b) => b.value === formValues.birdId) || null
                  }
                  label="Select Bird"
                  onSelect={(option) => handleSelectChange("birdId", option)}
                  isDisabled={!!props?.sifarishToEdit}
                />
              </div>
            )}

            {/* Category Select */}
            {categories.length > 0 && (
              <div className="_dualDivs">
                <CustomSelect
                  key={`category-select-${formValues.categoryId}`}
                  options={categories.map((c) => ({
                    label: c.title,
                    value: c._id,
                  }))}
                  value={
                    categories
                      .map((c) => ({ label: c.title, value: c._id }))
                      .find((c) => c.value === formValues.categoryId) || null
                  }
                  label="Select Category"
                  onSelect={(option) => {
                    const contentCategoryId = "6783b12f2767a48108c86780";

                    if (props?.sifarishToEdit) {
                      const currentCategoryId = formValues.categoryId;
                      const newCategoryId = option?.value;

                      if (
                        currentCategoryId === contentCategoryId &&
                        newCategoryId !== contentCategoryId
                      ) {
                        toast.error(
                          "You are not allowed to change the category from Content"
                        );

                        handleSelectChange("categoryId", {
                          label:
                            categories.find((c) => c._id === currentCategoryId)
                              ?.title || "-",
                          value: currentCategoryId,
                        });
                        return;
                      }

                      if (
                        currentCategoryId !== contentCategoryId &&
                        newCategoryId === contentCategoryId
                      ) {
                        toast.error(
                          "You are not allowed to select the Content category"
                        );

                        handleSelectChange("categoryId", {
                          label:
                            categories.find((c) => c._id === currentCategoryId)
                              ?.title || "-",
                          value: currentCategoryId,
                        });
                        return;
                      }
                    }

                    handleSelectChange("categoryId", option);
                    handleChange("subCategoryId", "");
                    handleChange("genreId", "");
                  }}
                  isDisabled={
                    !!props?.sifarishToEdit &&
                    formValues.categoryId === "6783b12f2767a48108c86780"
                  }
                />
              </div>
            )}

            {(() => {
              const selectedCatObj = categories.find(
                (c) => c._id === formValues.categoryId
              );
              const hasSubCategories =
                selectedCatObj &&
                Array.isArray(selectedCatObj.subCategories) &&
                selectedCatObj.subCategories.length > 0;

              if (!hasSubCategories) return null;

              return (
                <>
                  {subCategoryList.length > 0 && (
                    <div className="_dualDivs">
                      <CustomSelect
                        options={subCategoryList}
                        value={subCategoryList.find(
                          (sc) => sc.value === formValues.subCategoryId
                        )}
                        label="Select Subcategory"
                        onSelect={(option) => {
                          handleSelectChange("subCategoryId", option);
                          const subCat = selectedCatObj?.subCategories.find(
                            (sc) => sc._id === option.value
                          );
                          setSelectedSubCategoryData(subCat);
                        }}
                      />
                    </div>
                  )}

                  {selectedSubCategoryData?.isGenre && (
                    <div className="_dualDivs">
                      <CustomSelect
                        options={genresList}
                        value={genresList.find(
                          (g) => g.value === formValues.genreId
                        )}
                        label="Select Genre"
                        onSelect={(option) =>
                          handleSelectChange("genreId", option)
                        }
                      />
                    </div>
                  )}
                </>
              );
            })()}

            {selectedCategory && (
              <div className="__optionRadios">
                {constant.DETAIL_SEARCH_OPTION.map((option, idx) => (
                  <div className="_dualCheckr_bx" key={idx}>
                    <input
                      type="radio"
                      checked={formValues.isAuto === option.value}
                      onChange={() => handleChange("isAuto", option.value)}
                    />
                    <label>{option.label}</label>
                  </div>
                ))}
              </div>
            )}

            {selectedCategory === "Contents" &&
              selectedSubCategoryData?.isGenre ? (
              formValues.isAuto === 1 ? (
                <div className="_dualDivs">
                  <CommonMovieSearch
                    onMovieSelect={handleMovieSelect}
                    value={formValues.contentTitle}
                    onChange={(value) => handleChange("contentTitle", value)}
                  />
                </div>
              ) : (
                <></>
              )
            ) : (
              selectedCategory !== "Contents" && (
                <div className="_dualDivs">
                  {formValues.isAuto === 1 ? (
                    <GooglePlaceSearch
                      apiKey={process.env.NEXT_PUBLIC_GOOGLE_API_KEY}
                      onAddressChange={setLocationData}
                      onNearbyResults={setNearbyPlaces}
                    />
                  ) : (
                    <GooglePlaceSearch
                      apiKey={process.env.NEXT_PUBLIC_GOOGLE_API_KEY}
                      onAddressChange={setLocationData}
                      onNearbyResults={setNearbyPlaces}
                    />
                  )}
                </div>
              )
            )}

            {/* Main Form Section */}
            {(shouldShowMainForm ||
              (selectedCategory === "Contents" &&
                formValues.subCategoryId)) && (
                <>
                  <div className="_dualDivs">
                    <CommonInput
                      label="Title"
                      value={formValues.title}
                      onChange={(e) => handleChange("title", e.target.value)}
                      required
                    />
                  </div>

                  {/* Privacy Settings */}
                  <div className="__optionRadios">
                    {constant.COMMENT_VISIBILITY.map((option, idx) => (
                      <div className="_dualCheckr_bx" key={idx}>
                        <input
                          type="radio"
                          checked={formValues.privacy === option.value}
                          onChange={() => handleChange("privacy", option.value)}
                        />
                        <label>{option.label}</label>
                      </div>
                    ))}
                  </div>

                  {/* Description/Link Input */}
                  <div className="singleDiv">
                    <CommonTextarea
                      label={
                        selectedCategory === "Contents" &&
                          selectedSubCategoryData?.isGenre === true
                          ? "Description"
                          : selectedCategory === "Contents" &&
                            selectedSubCategoryData?.isGenre === false
                            ? "Description"
                            : "Comment"
                      }
                      value={formValues.description}
                      onChange={(e) =>
                        handleChange("description", e.target.value)
                      }
                    />
                  </div>

                  <>
                    {/* Links Section */}
                    <div style={{ flex: "0 0 100%" }}>
                      <p style={{ marginBottom: "6px", fontSize: "14px" }}>
                        Links
                      </p>

                      <div
                        className="_allDflx_nw"
                        style={{ flexDirection: "column", gap: "16px" }}
                      >
                        {formValues?.links?.map((link, index) => (
                          <div className="_allDflx_nw" key={index}>
                            <div className="_dualDivsCpy">
                              <CustomSelect
                                options={linkTypeOptions}
                                value={linkTypeOptions.find(
                                  (ol) =>
                                    ol.value ===
                                    formValues.links[index]?.linkTypeId
                                )}
                                label="Link Type"
                                onSelect={(option) =>
                                  handleArrayChange(
                                    "links",
                                    index,
                                    "linkTypeId",
                                    option.value
                                  )
                                }
                              />
                            </div>
                            <div className="_dualDivsCpy">
                              <CommonInput
                                label="URL"
                                value={formValues.links[index]?.url || ""}
                                onChange={(e) =>
                                  handleArrayChange(
                                    "links",
                                    index,
                                    "url",
                                    e.target.value
                                  )
                                }
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div
                                type="button"
                                onClick={() => handleRemoveLink(index)}
                              >
                                <MdDelete
                                  style={{ color: "red", fontSize: "18px" }}
                                />
                              </div>
                            </div>
                          </div>
                        ))}

                        <div style={{ marginTop: "10px", textAlign: "right" }}>
                          <div
                            type="button"
                            onClick={handleAddLink}
                            style={{ display: "inline-block" }}
                          >
                            + Add More
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Contact Info Section */}
                    {!selectedSubCategoryData?.isGenre &&
                      (selectedCategory === "Contents" ? (
                        <></>
                      ) : (
                        <div style={{ flex: "0 0 100%" }}>
                          <p style={{ marginBottom: "6px", fontSize: "14px" }}>
                            Contact Info
                          </p>
                          <div className="_allDflx_nw">
                            <div className="_dualDivs">
                              <CommonInput
                                label="Contact Person Name"
                                placeholder="Contact Person Name"
                                value={formValues.contactName || ""}
                                onChange={(e) =>
                                  handleChange("contactName", e.target.value)
                                }
                              />
                            </div>
                            <div className="_dualDivs">
                              <CommonInput
                                label="Phone Number"
                                placeholder="Phone Number"
                                value={formValues.phoneNumber || ""}
                                onChange={(e) =>
                                  handleChange("phoneNumber", e.target.value)
                                }
                              />
                            </div>
                            <div className="_dualDivs">
                              <CommonInput
                                label="Email"
                                placeholder="Email"
                                value={formValues.email || ""}
                                onChange={(e) =>
                                  handleChange("email", e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                  </>
                  {/* Media Upload Section */}
                  <div className="photo-gallery">
                    {formValues.mediaUrls.map((media, index) => (
                      <div key={`${media.url}-${index}`} className="photo-card">
                        <img
                          src={media.url}
                          alt={`Media ${index + 1}`}
                          className="place-image"
                        />

                        <span
                          className="__cancelBtn"
                          onClick={() => handleDeleteImg(media, index)}
                        >
                          <MdCancel />
                        </span>
                      </div>
                    ))}

                    <div className="w-100">
                      <input
                        type="file"
                        id="uploadImg"
                        style={{ display: "none" }}
                        accept="image/*"
                        className="hidden"
                        onChange={handleFileUpload}
                      />
                      <label htmlFor="uploadImg" className="__uploadImg">
                        <FaRegImage />
                        <p>Upload Image</p>
                      </label>
                    </div>
                  </div>
                </>
              )}
          </div>
        </div>
      </CommonModal>
    </>
  );
};

export default AddSifarishModal;
